import { useCallback, useEffect, useState } from 'react';

/**
 * Sliding window over a list (e.g. show 3 items; next drops #1 and reveals #4).
 * Keeps card height stable — no nested scroll, no expand.
 */
export function useSlidingWindow<T>(items: T[], windowSize = 3) {
  const [start, setStart] = useState(0);

  useEffect(() => {
    const maxStart = Math.max(0, items.length - windowSize);
    setStart((s) => Math.min(s, maxStart));
  }, [items.length, windowSize]);

  const maxStart = Math.max(0, items.length - windowSize);
  const canPrev = start > 0;
  const canNext = start < maxStart;
  const visible = items.slice(start, start + windowSize);
  const showNav = items.length > windowSize;

  const prev = useCallback(() => {
    setStart((s) => Math.max(0, s - 1));
  }, []);

  const next = useCallback(() => {
    setStart((s) => Math.min(Math.max(0, items.length - windowSize), s + 1));
  }, [items.length, windowSize]);

  return { visible, canPrev, canNext, prev, next, showNav, start };
}
